import { Input } from "@/components/ui/input";
import { Search, Package, Plus, X } from "lucide-react";

export function AddProductModal({
  open,
  onClose,
  productQuery,
  setProductQuery,
  productResults,
  draftItems,
  onAdd,
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4"
      onClick={onClose}
    >
      <div
        className="bg-[#18181b] border border-white/10 rounded-t-2xl sm:rounded-2xl w-full sm:max-w-lg max-h-[80vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <h3 className="text-white font-bold">Aggiungi articolo</h3>
          <button onClick={onClose} className="p-1 rounded text-zinc-400 hover:text-white">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 border-b border-white/10">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-400" />
            <Input
              autoFocus
              placeholder="Nome o codice articolo..."
              value={productQuery}
              onChange={(e) => setProductQuery(e.target.value)}
              className="pl-10 bg-[#09090b] border-white/10 h-9"
            />
          </div>
        </div>
        <div className="flex-1 overflow-y-auto p-2">
          {productQuery.trim().length < 2 && (
            <p className="text-zinc-500 text-xs text-center py-8">Digita almeno 2 caratteri</p>
          )}
          {productQuery.trim().length >= 2 && productResults.length === 0 && (
            <p className="text-zinc-500 text-xs text-center py-8">Nessun risultato</p>
          )}
          {productResults.map((p) => {
            const already = draftItems.some((it) => it.product_id === p.id);
            return (
              <button
                key={p.id}
                disabled={already}
                onClick={() => onAdd(p)}
                className={`w-full flex items-center gap-2 p-2 rounded-lg text-left transition-colors ${
                  already ? "opacity-40" : "hover:bg-white/5"
                }`}
              >
                <div className="w-8 h-8 rounded bg-white/5 flex items-center justify-center shrink-0">
                  {p.image_url ? (
                    <img src={p.image_url} alt="" className="w-full h-full object-cover rounded" />
                  ) : (
                    <Package className="w-4 h-4 text-zinc-500" />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-white text-xs font-medium truncate">{p.name}</p>
                  <p className="text-zinc-500 text-[10px] font-mono">{p.sku} · {p.price_list?.toFixed(2)}€</p>
                </div>
                {!already && <Plus className="w-4 h-4 text-blue-400" />}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
